import { h, Fragment } from "preact";
import "./radio.scss";

// todo: callback, focus, size

interface Props {
    id: string;
    name: string;
    value: string;
    label?: string;
    checked?: boolean;
    disabled?: boolean;
}

export const Radio = (props: Props) => {
    return (
        <div class="component-radio-container">
            <label for={props.id} class="component-radio">
                <input type="radio" id={props.id} name={props.name} value={props.value} disabled={props.disabled} checked={props.checked} />
                <span />
            </label>
            {
                props.label &&
                <label for={props.id}>
                    {
                        props.label
                    }
                </label>
            }
        </div>
    );
}
